import { useMutation, useQueryClient } from '@tanstack/react-query';
import Notify from '@/components/Notification';
import { QUERY_KEYS } from '@/query/queryKeys';
import { reportingService } from '../../services/reportingService';

export const useApplyReportingMode = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: payload =>
      reportingService.applyMode(payload).then(response => {
        const { status, data } = response;
        queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.reporting.pending_reports] });
        queryClient.setQueryData([QUERY_KEYS.reporting.status], () => data);
        if (status === 200) {
          Notify.success({ text: 'Reporting mode applied successfully' });
          return data;
        }
      }),
  });
};
